import apiClient from 'apiClient';
import { RepaymentStrategy as API } from './RepaymentStrategy';
import { RepaymentStrategy as Domain } from 'modules/cm/RepaymentStrategy/RepaymentStrategy';
import { apiToDomain, mapPartialDomainToPartialApi } from './mapper';

const update = async (apiPrefix: string, repaymentStrategy: Partial<Domain>): Promise<Domain> => {
  try {
    const { data } = await apiClient.patch<API>(`${apiPrefix}/`, mapPartialDomainToPartialApi(repaymentStrategy));
    return apiToDomain(data);
  } catch (e) {
    throw new Error('Could not update vulnerability.');
  }
};

export default update;
